// @flow

import type { InteractivesMenuItemConfig } from "../interactives-list";
import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import DisplayImage from "./image.png";
// import { ALL_USER_GROUPS_BUT_GUESTS } from '../../utils/constants'; - Hide until fixed

const description = "A widget for embedding a PDF onto an article.";

const CONFIG: InteractivesMenuItemConfig = {
  name: "PDF viewer",
  id: "pdf-viewer",
  groupsWithAccess: [], //ALL_USER_GROUPS_BUT_GUESTS, - Hide until fixed
  linkPrefix: "/interactives",
  tags: ["Configurable"],
  description,
  image: DisplayImage,
  adminOnly: false,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/pdfviewer/live/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "PDFViewerConfigTool" */ "app/components/tools/PDFViewerConfigTool/PDFViewerConfigTool"),
    loading: DynamicImportLoader,
    modules: ["PDFViewerConfigTool"]
  })
};

export default CONFIG;
